import l from '../../../../lang';
import CardConfirm from '../../../common/confirm/card-confirm';
import DialogConfirm from '../../../common/confirm/dialog-confirm';

interface DialogResendInviteProps {
  userEmail: string;
  onClose: (confirm: boolean) => void;
}

const DialogResendInvite = ({ userEmail, onClose }: DialogResendInviteProps) => {
  return (
    <DialogConfirm onClose={() => onClose(false)}>
      <CardConfirm
        onClose={onClose}
        headline={l('userManagement.resendInvite.title')}
        description={l('userManagement.resendInvite.body', `${userEmail}`)}
        confirmChildren={l('userManagement.resendInvite.confirm')}
        cancelChildren={l('userManagement.resendInvite.cancel')}
        level={'warning'}
      />
    </DialogConfirm>
  );
};

export default DialogResendInvite;
